import axios from "axios";
import toLogin from "./toLogin";

const backend = process.env.REACT_APP_BACKEND;

const getMenuInfo = {
  userMenu: async () => {
    //유저에 부여된 권한에 따른 메뉴그룹과 메뉴 가져오기
    return axios
      .get(`${backend}/admin_menu`)
      .then((data) => {
        return data.data.data;
      })
      .catch((err) => {
        if (err.response.status === 401) {
          console.log(err);
        }
        return [];
      });
  },
  menuGroupList: async () => {
    // 전체 메뉴그룹 가져오기
    return axios
      .get(`${backend}/admin_menu/menu_group`)
      .then((data) => {
        return data.data.data;
      })
      .catch((err) => {
        console.log(err)
        return [];
      });
  },
  menuList: async () => {
    //전체 메뉴 가져오기
    return axios
      .get(`${backend}/admin_menu/menu`)
      .then((data) => {
        return data.data.data;
      })
      .catch((err) => {
        console.log(err)
        return [];
      });
  },

  getAssignedMenu: async () => {
    return axios.get(`${backend}/admin_menu/assigned_menu`).then((data) => {
      return data.data.data
    })
    .catch(err =>{
      console.log(err)
        return []
    })
  },

  menuGroupOrder: async (newMenuGroup) => {
    // 메뉴 순서 바꾸기
    return axios
      .post(`${backend}/admin_menu/menuGroupOrder`, { newMenuGroup })
      .then((data) => {
        return [true, data.data.data];
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 401) {
          console.log(err);
          toLogin();
        }
        if (err.response.status === 500) {
          console.log(err);
        }
        return [false, []];
      });
  },

  menuOrder: async (newMenu) => {
    // 메뉴 순서 바꾸기
    return axios
      .post(`${backend}/admin_menu/menuOrder`, { newMenu })
      .then((data) => {
        return [true, data.data.data];
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 401) {
          console.log(err);
          toLogin();
        }
        if (err.response.status === 500) {
          console.log(err);
        }
        return [false, []];
      });
  },
};

export default getMenuInfo;
